import React, { useContext } from "react";
import { themeContext } from "../context";
import { colors } from "../constants/colors";

const MoonIcon = ({ color }) => (
  <svg
    viewBox="0 0 24 24"
    width="14"
    height="14"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M20.354 15.354A8.5 8.5 0 0 1 8.646 3.546a8.5 8.5 0 1 0 11.708 11.808Z"
      fill={color}
    />
  </svg>
);

const SunIcon = ({ color }) => (
  <svg
    viewBox="0 0 24 24"
    width="14"
    height="14"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="12" cy="12" r="4" fill={color} />
    <path
      d="M12 2v2.5M12 19.5V22M4.93 4.93l1.77 1.77M17.3 17.3l1.77 1.77M2 12h2.5M19.5 12H22M4.93 19.07l1.77-1.77M17.3 6.7l1.77-1.77"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const Togle = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  const clickHandler = () => {
    theme.dispatch({ type: "togle" });
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        border: `2px solid ${darkMode ? "rgba(73, 177, 82, 0.35)" : "#dfe6eb"}`,
        background: darkMode ? "rgba(255,255,255,0.05)" : "#edf2f5",
        position: "relative",
        borderRadius: "999px",
        padding: "2px 4px",
        cursor: "pointer",
        width: "64px",
        height: "28px",
        transition: "all 0.35s ease",
      }}
      onClick={clickHandler}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <MoonIcon color={darkMode ? colors.primary : "#90a4ae"} />
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <SunIcon color={darkMode ? "#9aa8b5" : colors.primary} />
      </div>
      <div
        style={{
          borderRadius: "50%",
          position: "absolute",
          background: colors.primary,
          height: "1.2rem",
          width: "1.2rem",
          boxShadow: darkMode
            ? "0 4px 12px rgba(73, 177, 82, 0.35)"
            : "0 4px 12px rgba(15, 23, 42, 0.12)",
          transition: "left 0.3s ease, right 0.3s ease",
          ...(darkMode ? { left: "4px" } : { right: "4px" }),
        }}
      ></div>
    </div>
  );
};

export default Togle;
